import React, { useState } from 'react';

import CustomSlider from '@components/common/CustomSlider/CustomSlider';
import useTranslateLpc from '@components/common/hooks/useTranslateLpc';
import Text from '@components/common/Text/Text';

import css from './LoginSlider.module.scss';

const LoginSlider = () => {
    const { t } = useTranslateLpc('lpc-authentication');
    const slideArray = [
        {
            id: 0,
            imgSrc: '/front-static/icons/authentication/tab-0.svg',
            bgSrc: '/front-static/icons/authentication/bg-0.png',
            title: t(`login.right.0.title`),
            desc: t(`login.right.0.desc`),
        },
        {
            id: 1,
            imgSrc: '/front-static/icons/authentication/tab-1.svg',
            bgSrc: '/front-static/icons/authentication/bg-1.png',
            title: t(`login.right.1.title`),
            desc: t(`login.right.1.desc`),
        },
    ];

    const [activeTab, setActiveTab] = useState(0);

    const paging = (index) => {
        return (
            <div>
                <span className={`${css.slider__dots} ${activeTab === index && css.slider__dots__active}`} />
            </div>
        );
    };

    return (
        <div className={css.wrapper}>
            <CustomSlider
                onActiveStep={(value) => setActiveTab(value)}
                customPaging={(index) => paging(index)}
                sliderClass={css.slider}
                autoplay={true}
                autoplaySpeed={5000}
                dots={true}
            >
                {slideArray.map((item) => (
                    <div key={item.id} className={css.slider__content}>
                        <div className={css.slider__bg} style={{ backgroundImage: `url(${item.bgSrc})` }}>
                            <img className={css.slider__img} src={item.imgSrc} alt="login" />
                            <section className={css.slider__content__txt}>
                                <h4> {item.title}</h4>
                                <Text variant={'body_02'} color={'txt-primary'}>
                                    {item.desc}
                                </Text>
                            </section>
                        </div>
                    </div>
                ))}
            </CustomSlider>
        </div>
    );
};

export default LoginSlider;
